<p>
  payment-details works!
</p>
